import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import Button from "react-bootstrap-button-loader";
import { DISPLAY_LOCAL_DATE_FORMAT, converDateIntoLocal } from "Constants";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";
class ExportRatingExcelBtn extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }
  componentDidMount() {
    // window.addEventListener("load", this.props.getAllSession());
  }

  componentWillUnmount() {
    // window.removeEventListener("load", this.props.getAllSession());
  }

  downloadCSV = () => {
    let {
      settingData,
      singleSessionCheckouForm,
      allSessionId,
      singleSessionRatings,
    } = this.props;

    let formItems =
      settingData &&
      settingData.length > 0 &&
      settingData[0].event_forms_by_sesseionratingformid
        ? JSON.parse(
            settingData[0].event_forms_by_sesseionratingformid.formjson
          )
        : [];

    if (singleSessionCheckouForm.data.sessionratingid) {
      formItems = JSON.parse(
        singleSessionCheckouForm.data.event_forms_by_sessionratingid.formjson
      );
    }

    let data = singleSessionRatings.resource;
    this.setState({ loading: true });
    let excelArr = [];

    _.forEach(data, (value, index) => {
      let jsonobj = JSON.parse(value.response);
      let title = value.session_by_sessionid
        ? value.session_by_sessionid.title
        : "";
      let username = value.appuser_by_appuserid.username;
      let email = value.appuser_by_appuserid.email;
      let date = converDateIntoLocal(value.updatedon);

      let obj = {
        "Session Title": title,
        "User Name": username,
        Email: email,
      };
      _.forEach(formItems, (form, i) => {
        var key = form.key;

        if (key !== "hyperlink" && key !== "label" && key !== "paragraph") {
          let filter = _.filter(jsonobj, (obj) => {
            return obj.name == form.name;
          });

          var value = "-";
          if (filter.length > 0) {
            value = filter[0].value;

            if (value === "" || value == 0 || value == "0.0") value = "-";
            else value = value;

            if (key === "dropdown" || key === "dropdown") {
              var options = form.options;
              var checkValue = _.filter(options, function (opt) {
                return opt.text === value || opt.value === value;
              });

              value = checkValue.length > 0 ? checkValue[0].text : "-";
            }

            if (key === "checkboxes") {
              var options = form.options;

              var displayValue = [];
              _.map(value, (box) => {
                var checkValue = _.filter(options, function (opt) {
                  return opt.text === box || opt.value === box;
                });

                if (checkValue && checkValue.length > 0) {
                  displayValue.push(checkValue[0].text);
                }
              });

              value = displayValue.length > 0 ? displayValue.join(",") : "-";
            }

            if (key === "rating" && value) {
              value = value !== "-" ? parseInt(value) : value;
            }

            if (key === "datepicker") {
              var timestamp = Date.parse(value);
              if (isNaN(timestamp) == false) {
                value = moment(timestamp).format(DISPLAY_LOCAL_DATE_FORMAT);
              } else {
                value = "-";
              }
            }
          }

          obj[form.label] = value;
        }
      });

      obj["Submitted on"] = date;

      excelArr.push(obj);
    });

    if (!_.isEmpty(excelArr)) {
      let rating = {
        rating: excelArr,
      };
      this.props.JSONToCSVConvertor(rating, true);
      this.setState({ loading: false });
    } else {
      this.props.showError(LocaleStrings.no_data_found);
      this.setState({ loading: false });
    }
  };

  downloadAllCSV = () => {
    let { settingData, allSessionRatings } = this.props;

    let formItems =
      settingData &&
      settingData.length > 0 &&
      settingData[0].event_forms_by_sesseionratingformid
        ? JSON.parse(
            settingData[0].event_forms_by_sesseionratingformid.formjson
          )
        : [];
    this.setState({ loading: true });

    let data = allSessionRatings.resource;

    let excelArr = [];
    _.forEach(data, (value, index) => {
      let jsonobj = JSON.parse(value.response);
      let sessionid = value.sessionid;
      let title = value.session_by_sessionid
        ? value.session_by_sessionid.title
        : "";
      let username = value.appuser_by_appuserid.username;
      let email = value.appuser_by_appuserid.email;
      let date = converDateIntoLocal(value.updatedon);

      let obj = {
        id: sessionid,
        "Session Title": title,
        "User Name": username,
        Email: email,
      };

      _.forEach(jsonobj, (form, i) => {
        var key = form.key;

        if (key !== "hyperlink" && key !== "label" && key !== "paragraph") {
          var value = "-";

          if (form.value && form.value !== "") {
            value = form.value;
            // console.log("value :- ", value);
            if (value == 0 || value == "0.0") value = "-";
            else value = value;

            if (key === "dropdown" || key === "dropdown") {
              var options = form.options;
              var checkValue = _.filter(options, function (opt) {
                return opt.text === value || opt.value === value;
              });

              value = checkValue.length > 0 ? checkValue[0].text : "-";
            }

            if (key === "checkboxes") {
              var options = form.options;

              var displayValue = [];
              _.map(value, (box) => {
                var checkValue = _.filter(options, function (opt) {
                  return opt.text === box || opt.value === box;
                });

                if (checkValue && checkValue.length > 0) {
                  displayValue.push(checkValue[0].text);
                }
              });

              value = displayValue.length > 0 ? displayValue.join(",") : "-";
            }

            if (key === "rating") {
              value = value !== "-" ? parseInt(value) : value;
            }

            if (key === "datepicker") {
              var timestamp = Date.parse(value);
              if (isNaN(timestamp) == false) {
                value = moment(timestamp).format(DISPLAY_LOCAL_DATE_FORMAT);
              } else {
                value = "-";
              }
            }
          }

          obj[form.label] = value;
        }
      });

      obj["Submitted on"] = date;
      excelArr.push(obj);
    });
    // console.log("excelArr :- ", excelArr);

    if (!_.isEmpty(excelArr)) {
      const groupBySession = excelArr.reduce((group, item) => {
        const { id } = item;
        group[id] = group[id] ?? [];
        group[id].push(item);
        return group;
      }, {});
      // console.log("groupBySession :- ", groupBySession);

      // Remove session id as its not required anymore
      _.map(groupBySession, (o) => {
        o.forEach(function (v) {
          delete v.id;
        });
      });
      // console.log("groupBySession after :- ", groupBySession);

      this.props.AllRatingCSVConverter(groupBySession, true);
      this.setState({ loading: false });
    } else {
      this.props.showError(LocaleStrings.no_data_found);
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <>
        {/*       <div>
          <span className="pull-right">
            <Button
              className="btn btn-custom-blue"
              onClick={this.downloadCSV}
              loading={this.state.loading}
            >
              <i className="fa fa-download i-custom-ms" aria-hidden="true" />
              This session
            </Button>
          </span>
          <span className="pull-right">
            <Button
              className="btn btn-custom-blue"
              onClick={this.downloadCSV}
              loading={this.state.loading}
            >
              <i className="fa fa-download i-custom-ms" aria-hidden="true" />
              All session
            </Button>
          </span>
        </div> */}
        <div className="dropdown-btn-container">
          <DropdownButton
            className="dropdown-blue-btn"
            title={LocaleStrings.button_csv_export}
            key="1"
            id="dropdown-basic-2"
            nocaret="true"
          >
            <Dropdown.Item onClick={this.downloadCSV}>
              <i className="fa fa-download i-custom-ms" aria-hidden="true" />
              This session
            </Dropdown.Item>
            <Dropdown.Item onClick={this.downloadAllCSV}>
              <i className="fa fa-download i-custom-ms" aria-hidden="true" />
              All session
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    settingData: state.SettingData.resource,
    singleSessionCheckouForm: state.singleSessionCheckouForm,
    singleSessionRatings: state.singleSessionRatings,
    allSessionRatings: state.allSessionRatings,
    allSessionId: state.allSessionId,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
})(ExportRatingExcelBtn);
